export const nightImage = `url("https://i.postimg.cc/T2q7G0ry/dark-night-half-moon-vector-260nw-1567237021.webp")`;
export const dayImage = `url("https://i.postimg.cc/yxMYLKvd/vector-sky-and-sun-background.jpg")`;
